import { render } from "./right-panel.vue?vue&type=template&id=b48af76a"
import script from "./right-panel.vue?vue&type=script&lang=js"
export * from "./right-panel.vue?vue&type=script&lang=js"
script.render = render

export default script